export default {
  dynamicAttributes: [],
}
